import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaPhp,
  FaReact,
  FaVuejs,
  FaLaravel,
  FaSymfony,
  FaGitAlt,
  FaDocker,
  FaAws,
  FaDatabase,
  FaPython,
  FaSass,
  FaUserTie,
  FaUsers,
  FaClock,
  FaLightbulb,
  FaChartLine,
  FaSearch,
  FaCheckDouble,
  FaBrain,
  FaNodeJs,
  FaCode,
  FaCodeBranch,
  FaServer,
  FaLayerGroup,
  FaRobot,
  FaTools,
  FaClipboardCheck,
  FaProjectDiagram,
  FaBook,
  FaMicrosoft,
} from "react-icons/fa";
import {
  SiTypescript,
  SiNextdotjs,
  SiTailwindcss,
  SiMysql,
  SiPostgresql,
  SiMongodb,
  SiKubernetes,
  SiJest,
  SiCypress,
  SiReact,
  SiStorybook,
  SiFigma,
  SiExpress,
  SiNestjs,
  SiRedux,
  SiJquery,
  SiDjango,
  SiSqlite,
  SiOpenai,
  SiBun,
  SiXstate,
  SiN8N,
  SiPrisma,
} from "react-icons/si";
import { TbBrandCSharp } from "react-icons/tb";

export type Category = "code" | "framework" | "tool" | "design" | "database" | "ia" | "devops" | "other";

type Skill = {
  name: string;
  years: number;
  category: Category;
  icon: React.ReactNode;
};

type SoftSkill = {
  name: string;
  icon: React.ReactNode;
};

type Methodology = {
  name: string;
  icon: React.ReactNode;
};

const skills: Skill[] = [
  { name: "PHP", years: 9, category: "code", icon: <FaPhp className="text-indigo-500" /> },
  { name: "JavaScript", years: 13, category: "code", icon: <FaJs className="text-yellow-500" /> },
  { name: "TypeScript", years: 8, category: "code", icon: <SiTypescript className="text-blue-600" /> },
  { name: "HTML", years: 13, category: "code", icon: <FaHtml5 className="text-orange-500" /> },
  { name: "CSS", years: 13, category: "code", icon: <FaCss3Alt className="text-blue-500" /> },
  { name: "SQL", years: 13, category: "code", icon: <FaDatabase className="text-gray-600" /> },
  { name: "Python", years: 2, category: "code", icon: <FaPython className="text-blue-500" /> },
  { name: "C#", years: 5, category: "code", icon: <TbBrandCSharp className="text-blue-600" /> },

  { name: "React", years: 9, category: "framework", icon: <FaReact className="text-cyan-500" /> },
  { name: "Node.js", years: 9, category: "framework", icon: <FaNodeJs className="text-green-600" /> },
  { name: "Bun.js", years: 1, category: "framework", icon: <SiBun className="text-black dark:text-white" /> },
  { name: "React Native", years: 3, category: "framework", icon: <FaReact className="text-cyan-500" /> },
  { name: "Next.js", years: 7, category: "framework", icon: <SiNextdotjs className="text-black dark:text-white" /> },
  { name: "Laravel", years: 3, category: "framework", icon: <FaLaravel className="text-red-500" /> },
  { name: "Symfony", years: 9, category: "framework", icon: <FaSymfony className="text-black dark:text-white" /> },
  { name: "Api Platform", years: 3, category: "framework", icon: <></> },
  { name: "Vue.js", years: 1, category: "framework", icon: <FaVuejs className="text-emerald-500" /> },
  { name: "Nest.js", years: 2, category: "framework", icon: <SiNestjs className="text-red-600" /> },
  { name: "Express.js", years: 4, category: "framework", icon: <SiExpress className="text-gray-600" /> },
  { name: "xState", years: 2, category: "framework", icon: <SiXstate className="text-purple-600" /> },
  { name: "Redux", years: 6, category: "framework", icon: <SiRedux className="text-purple-600" /> },
  { name: "jQuery", years: 6, category: "framework", icon: <SiJquery className="text-blue-600" /> },
  { name: "Django", years: 2, category: "framework", icon: <SiDjango className="text-green-800" /> },
  { name: "Prisma", years: 3, category: "framework", icon: <SiPrisma className="text-black dark:text-white" /> },

  { name: "Tailwind CSS", years: 4, category: "design", icon: <SiTailwindcss className="text-cyan-400" /> },
  { name: "SCSS/SASS", years: 8, category: "design", icon: <FaSass className="text-pink-500" /> },

  { name: "Git", years: 13, category: "tool", icon: <FaGitAlt className="text-orange-600" /> },
  { name: "Cypress", years: 6, category: "tool", icon: <SiCypress className="text-gray-600" /> },
  { name: "Jest", years: 6, category: "tool", icon: <SiJest className="text-red-600" /> },
  { name: "React Testing Library", years: 6, category: "tool", icon: <SiReact className="text-red-400" /> },
  { name: "Figma", years: 6, category: "tool", icon: <SiFigma className="text-purple-400" /> },
  { name: "Storybook", years: 6, category: "tool", icon: <SiStorybook className="text-pink-600" /> },

  { name: "Docker", years: 7, category: "devops", icon: <FaDocker className="text-blue-500" /> },
  { name: "AWS", years: 1, category: "devops", icon: <FaAws className="text-orange-400" /> },
  { name: "Azure", years: 1, category: "devops", icon: <FaMicrosoft className="text-blue-600" /> },
  { name: "CI/CD", years: 7, category: "devops", icon: <FaCodeBranch className="text-gray-600" /> },
  { name: "Kubernetes", years: 3, category: "devops", icon: <SiKubernetes className="text-blue-600" /> },

  { name: "MySQL", years: 10, category: "database", icon: <SiMysql className="text-blue-600" /> },
  { name: "PostgreSQL", years: 8, category: "database", icon: <SiPostgresql className="text-blue-500" /> },
  { name: "MongoDB", years: 7, category: "database", icon: <SiMongodb className="text-green-500" /> },
  { name: "SQLite", years: 2, category: "database", icon: <SiSqlite className="text-blue-400" /> },

  { name: "MCP", years: 1, category: "ia", icon: <FaServer className="text-purple-600" /> },
  { name: "OpenAI", years: 1, category: "ia", icon: <SiOpenai className="text-green-600" /> },
  { name: "Agent IA", years: 1, category: "ia", icon: <FaRobot className="text-gray-600" /> },
  { name: "n8n", years: 1, category: "ia", icon: <SiN8N className="text-orange-600" /> },

  { name: "Open Api", years: 2, category: "other", icon: <FaBook className="text-green-600" /> },
];

const methodologies: Methodology[] = [
  { name: "Clean Code", icon: <FaCode className="text-blue-600" /> },
  { name: "Agilité", icon: <FaTools className="text-orange-600" /> },
  { name: "MVC", icon: <FaLayerGroup className="text-indigo-600" /> },
  { name: "TDD", icon: <FaClipboardCheck className="text-green-600" /> },
  { name: "DDD", icon: <FaProjectDiagram className="text-purple-600" /> },
  { name: "POO", icon: <FaCode className="text-yellow-600" /> },
  { name: "Test unitaire/E2E", icon: <FaCheckDouble className="text-green-600" /> },
];

const softSkills: SoftSkill[] = [
  { name: "Communication", icon: <FaUserTie className="text-blue-400" /> },
  { name: "Résolution de problèmes", icon: <FaLightbulb className="text-yellow-400" /> },
  { name: "Gestion du temps", icon: <FaClock className="text-amber-400" /> },
  { name: "Travail d'équipe", icon: <FaUsers className="text-green-400" /> },
  { name: "Leadership", icon: <FaChartLine className="text-red-400" /> },
  { name: "Souci du détail", icon: <FaSearch className="text-purple-400" /> },
  { name: "Adaptabilité", icon: <FaCheckDouble className="text-teal-400" /> },
  { name: "Esprit critique", icon: <FaBrain className="text-pink-400" /> },
];

export const getCategories = (): Category[] => {
  const categories = new Set(skills.map((skill) => skill.category));
  return Array.from(categories);
};

export { skills, softSkills, methodologies };
